<template>
	<div :name="name" class="w5-file-component" @click="clearErrors">
		<!-- итем -->
		<div v-for="(item, indx) in currentValue"
			class="w5-file-uploader-item"
			:key="'item-' + indx"
			:class="{ 'multiple-item': multiple }">
			<!-- враппер картинки -->
			<div class="w5-file-uploader-item-image-wrapper" @click="previewImage(item)">
				<template v-if="item.type && String(item.type).substr(0, 5).toLowerCase() === 'image'">
					<img v-if="item.image.src" :src="item.image.src" :style="'width:' + item.imgWidth + 'px;height:' + item.imgHeight + 'px;'" />
					<font-awesome-icon v-else icon="image" />
				</template>
				<template v-else>
					<div class="attach-no-image-preview-file-uploader">{{ item.ext }}</div>
				</template>
			</div>
			<!-- название файла -->
			<div class="w5-file-uploader-item-title">{{ item.title | ftc }}</div>
			<!-- размер файла -->
			<div class="w5-file-uploader-item-size">
				<span v-if="item.status === 'done' && item.size">{{ item.size | bytes }}</span>
				<span v-if="item.status === 'loading' || item.status === 'uploading'" class="font-size-85"><img src="/static/img/loading-hor16.gif" /><br>{{ item.progress ? item.progress : '' }}</span>
			</div>
			<!-- блок загрузчика и кнопки удаления -->
			<div v-if="crud !== 'twofa'" class="w5-file-uploader-item-buttons">
				<font-awesome-icon v-if="item.status === 'done'"
					:title="'main/delete' | ftc"
					@click="deleteItem(item)"
					icon="trash-alt"
				/>
				<font-awesome-icon v-if="item.status === 'loading' || item.status === 'uploading'"
					:title="'main/cancel' | ftc"
					@click="cancelUploading(item)"
					icon="times-circle"
				/>
				<font-awesome-icon v-if="item.status === 'crop'"
					class="miganie-animation"
					title="Обрезка"
					icon="cut"
				/>
			</div>
			<!-- если файл загружен -->
			<input v-if="item.keyfile" type="hidden" :value="item.keyfile" />
		</div>

		<!-- кнопка аттача файла -->
		<span v-show="buttonVisibility" class="w5-file-add-button">
			<font-awesome-icon icon="paperclip" /><div class="w5-file-add-button-caption">{{ buttonTitle }}</div>
			<input v-if="multiple"
				type="file"
				ref="fileUploaderInput"
				name="w5-file-uploader[]"
				multiple="multiple"
				@change="onSelect" />
			<input v-else
				type="file"
				ref="fileUploaderInput"
				name="w5-file-uploader"
				@change="onSelect" />
		</span>

		<span class="clearfix"></span>
		<!-- Блок с ошибками -->
		<div v-show="errors !== ''" class="alert alert-danger w5-alert-valid" role="alert" v-withSafeTags="localeFtc(errors)"></div>

		<!-- диалог просмотра -->
		<transition name="modal">
			<div v-show="showModal" @click="closeDialog($event, false, true)" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop :style="'width:' + modalWidth + 'px;'">

						<!-- заголовок -->
						<div class="modal-header">
							<button type="button" class="close" @click="closeDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<img ref="imageInDialog" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'" />
						</div>

						<!-- подвал -->
						<div v-show="modalCrop" class="modal-footer" style="padding: 5px 5px 7px; text-align: center;">
							<div class="w5-image-preview-crop-wrapper">
								<img ref="previewCropSquare" class="w5-image-preview-crop" />
							</div>
							<div class="w5-image-preview-crop-wrapper round">
								<img ref="previewCropRound" class="w5-image-preview-crop" />
							</div>
							<br>							
							<span class="btn btn-submit btn-submut-small" @click="finishCrop">{{ 'notes/file_type' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import $ from 'jquery'
import 'jcrop'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'fileComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['name', 'title', 'value', 'multiple', 'crud', 'accept', 'maxsize', 'maxcnt', 'candel'],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// значение поля - всегда массив объектов
			currentValue: [],
			// максимальное количество файлов
			maxcount: 1,
			// ошибки загрузки
			errors: '',
			// показ диалога
			showModal: false,
			// ширина диалога - рассчитывается каждый раз
			modalWidth: 0,
			// заголовок дилога
			modalText: '',
			// crop в диалоге или нет
			modalCrop: false,
			// ID итема в диалоге
			modalItemID: 0,
			// размеры картинки в диалоге
			imageWidth: 0,
			imageHeight: 0,
			// настоящие размеры картинки
			imageNaturalWidth: 0,
			imageNaturalHeight: 0,
			// превьюшки для Crop
			$square: null,
			$round: null,
			// координаты Crop
			cropCoords: null,
			// коэффициент сжатия изображения
			scaleKoeff: 1
		}
	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	created() {
		// максимальное количество файлов
		if (this.maxcnt) this.maxcount = this.maxcnt

		// если это мультифайл
		if (this.multiple)
		{
			// если задано начальное значение
			if (this.value && Array.isArray(this.value) && this.value.length)
			{
				// пока ничего не предусмотрено для этого случая TODO
			}
		}
		// это одиночное значение
		else
		{
			// было задано какое то начальное значение
			if (this.value)
			{
				// частные случаи
				if (this.crud === 'options' && this.value === '/uploads/avatars/default.jpg')
				{
					// пока как минимум не добавляем
				}
				else
				{
					// уникальный ключ
					let _id = Helper.unixTime(true)

					this.currentValue.push({
						'id': _id,
						'url': this.value,
						'ext': Helper.getFileExt(this.value).toUpperCase().substr(0, 4),
						'type': this.getTypeByName(this.value),
						'title': 'main/loaded_image',
						'status': '',
						'size': 0,
						'local': false,
						'keyfile': null
					})

					// загружаем файл
					this.loadFile(_id)
				}
			}
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		this.$nextTick(function() {
			// навешиваем обработчик на нажатие клавиш
			document.addEventListener('keydown', this.keyDownHandler)
			// событие - копирование из буфера
			window.addEventListener('paste', this.pasteFromClipboard)
		})
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// убираем обработчики
		document.removeEventListener('keydown', this.keyDownHandler)
		window.removeEventListener('paste', this.pasteFromClipboard)
		// отменяем все имеющиеся загрузки
		this.currentValue.forEach(item => {
			this.cancelUploading(item)
		})
	},
	//=========================================================================
	// вычисляемые переменные
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// заголовок кнопки
		//---------------------------------------------------------------------
		buttonTitle() {
			let _title = ''

			if (this.multiple === true)
			{
				_title = this.localeFtc('main/attach' + ' ' + (this.title ? this.title : 'main/files')).toLowerCase()
			}
			else
			{
				if (this.crud !== 'iso')
					_title = this.localeFtc('main/attach' + ' ' + (this.title ? this.title : 'ticketattach/path')).toLowerCase()
				else
					_title = this.localeFtc(this.title).toLowerCase()
			}

			return this.formater_capitalizeFirstChar(_title)
		},
		//---------------------------------------------------------------------
		// видима кнопка или нет
		//---------------------------------------------------------------------
		buttonVisibility() {
			// для мультифайла кнопка всегда доступна
			if (this.multiple === true) return true
			// для одиночного файла, кнопка доступна только когда нет значения
			if (this.currentValue && this.currentValue.length) return false
			else return true
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// загружает картинку
		//---------------------------------------------------------------------
		loadFile(id, crossDomain) {
			// обнулим ошибку
			this.errors = ''

			// если не указан ID итема
			if (!id)
			{
				this.errors = 'main/no_data'
				return
			}

			// ищем такой элемент в массиве по его ID
			let _el = false
			this.currentValue.some(item => {
				if (item.id === id)
				{
					_el = item
					return true
				}
			})
			// если не нашли элемент
			if (!_el)
			{
				this.errors = 'main/no_data'
				return
			}

			// элемент есть, нужно загрузить и получить его размер
			_el['size'] = _el['local'] && _el['local']['size'] ? _el['local']['size'] : 0
			_el['imgWidth'] = 0
			_el['imgHeight'] = 0

			// если это изображение - создаем обработчики
			if (_el['type'] && String(_el['type']).substr(0, 5).toLowerCase() === 'image')
			{
				_el['image'] = new Image()
				let _this = this
				// обработчик окончания загрузки картинки
				_el['image'].onload = function(e) {
					// получим реальные размеры картинки
					let _w = _el['image'].naturalWidth
					let _h = _el['image'].naturalHeight

					// вычислим кофф, 35 - это размер превьюшки
					let _k = 1
					if (_w > _h) _k = 35 / _w
					else _k = 35 / _h
					// получим размеры с учетом коффа
					_el['imgWidth'] = parseInt(_k * _w)
					_el['imgHeight'] = parseInt(_k * _h)

					// crop требуется только для "options"
					if (_this.crud === 'options')
					{
						// если загрузили с диска
						if (_el['local'])
						{
							// статус по умолчанию - crop
							_el['status'] = 'crop'
							// ставим метку Crop - разрешаем показ диалога обрезки
							_this.modalCrop = true
							// сразу покажем диалог
							_this.previewImage(_el)
						}
						else
						{
							_el['status'] = 'done'
						}
					}
					// crop не требуется
					else _el['status'] = 'done'

					// насильно обновляем
					_this.$forceUpdate()
				}

				// если нужно считать с диска
				if (_el['local'])
				{
					// сразу считываем в источник весь файл
					_el['image'].src = window.URL.createObjectURL(_el['local'])
				}
				// если нужно забрать с сервера
				else
				{
					// если картинка в виде кодированного изображения
					if (_el['url'].indexOf('data:image/') === 0)
					{
						_el['image'].src = _el['url']
					}
					else
					{
						// объект-запроса
						let xmlHTTP = new XMLHttpRequest()
						// url
						let _url = ''
						if (_el['url'].indexOf('http://') === 0 || _el['url'].indexOf('https://') === 0)
						{
							_url = _el['url']
							crossDomain = true
						}
						else
							_url = this.APIServerUrl + _el['url']
						xmlHTTP.open('GET', _url, true)
						// если кроссдоменный запрос
						if (crossDomain) xmlHTTP.withCredentials = true
						// тип
						xmlHTTP.responseType = 'arraybuffer'
						// при успешной загрузке в виде BLOB
						xmlHTTP.onload = function(e) {
							let blob = new Blob([this.response])
							_el['size'] = e.loaded
							_el['image'].src = window.URL.createObjectURL(blob)
						}

						// стартуем загрузку
						xmlHTTP.send()
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// загрузка файла на сервер
		//---------------------------------------------------------------------
		uploadFile(id) {
			// обнуляем ошибку
			this.errors = ''

			// если не указан ID итема
			if (!id)
			{
				this.errors = 'main/no_data'
				return
			}

			// ищем такой элемент в массиве по его ID
			let _el = false
			this.currentValue.some(item => {
				if (item.id === id)
				{
					_el = item
					return true
				}
			})
			// если не нашли
			if (!_el)
			{
				this.errors = 'main/no_data'
				return
			}

			// формируем URL согласно API
			let _this = this
			let _url = this.APIServerUrl + '/upload/set'
			if (_el['type'] && String(_el['type']).substr(0, 5) === 'image') _url += '/image'

			// формируем данные для передачи
			let _formData = new FormData()
			_formData.append('file', _el['local'])

			// начинаем загрузку
			_el['status'] = 'uploading'
			_el['progress'] = 0

			// старый, добрый Ajax, раз уж используем кроп
			_el['xhr'] = $.ajax({
				// стандартные настройки
				type: 'POST',
				url: _url,
				data: _formData,
				crossDomain: true,
				cache: false,
				contentType: false,
				processData: false,
				xhrFields: {
					withCredentials: true
				},
				// определим объект запроса с дополнительным обработчиком события "progress"
				xhr: function() {
					var xhr = new XMLHttpRequest()
					// прогресс загрузки на сервер
					xhr.upload.addEventListener('progress', function(evt) {
						if (evt.lengthComputable)
						{
							let percentComplete = evt.loaded / (evt.total ? evt.total : 1) * 100.0
							_el['progress'] = percentComplete.toFixed(0) + '%'
							_this.$forceUpdate()
						}
					}, false)
					return xhr
				},
				// перед запросом
				beforeSend: function(xhr, obj) {
					// увеличим счетчик активных загрузок файлов
					_this.$store.commit('uploadFileCounter', '+')
					// форма изменена
					_this.$store.commit('changedForm', _this.$route.path)
					// блокируем кнопку формы
					_this.$emit('blockFormButton')
				},
				// при упешном ответе сервера
				success: function(data, txt, xhr) {
					// файл успешно загружен на сервер, и мы получили ключ файла
					if (data && 'status' in data && data['status'] === 'ok' &&
						'file' in data && data['file'] &&
						'key' in data['file'] && data['file']['key'])
					{
						// запомним полученный ключ
						_el['keyfile'] = data['file']['key']
						// сообщим родителям о смене значения
						_this.$emit('input', _this.makeCurValue())
						// значение указано, значит удалять ничего не нужно - все перетрется
						_this.$emit('deleteFileValue', { 'field': _this.name, 'value': false })
						// обновим UI
						_this.$forceUpdate()
						// дадим знать родителю что закончилась закачка
						_this.$emit('uploadFinished')
						// все
						return
					}

					// ошибка
					_this.errors = 'upload/some_error'
				},
				// ошибка загрузки
				error: function(data) {
					// если это мы прервали загрузку - ничего не делаем
					if (data.statusText === 'abort') return
					// ошибка
					_this.errors = 'upload/some_error'
				},
				// при любом результате
				complete: function(jqXHR, textStatus) {
					// уменьшим счетчик активных загрузок файлов
					_this.$store.commit('uploadFileCounter', '-')
					// меняем статус
					_el['status'] = 'done'
					// разблокируем кнопку формы
					_this.$emit('unblockFormButton')
				}
			})
		},
		//---------------------------------------------------------------------
		// удаляет итем
		//---------------------------------------------------------------------
		deleteItem(item) {
			// обнуляем ошибку
			this.errors = ''

			// проверки
			if (!item) return
			if (!this.currentValue || !this.currentValue.length) return

			// если это множественный селект
			if (this.multiple)
			{
				// найдем элемент в значениях
				let _idx = this.currentValue.indexOf(item)
				// если не нашли
				if (_idx < 0) return
				// если есть ключ загрузки - удалим с сервера
				if (item['keyfile'] && item['keyfile'] !== '')
					this.deleteFromServer(item['keyfile'])
				// удалим элемент из массива значений
				this.currentValue.splice(_idx, 1)
			}
			// для одиночного селекта - тут и так понятно что первый элемент
			else
			{
				// сообщаем родителю что обнуляют поле, если это разрешено
				if (this.candel) this.$emit('deleteFileValue', { 'field': this.name, 'value': true })

				// если есть ключ загрузки - удалим с сервера
				if (this.currentValue && this.currentValue[0] && this.currentValue[0]['keyfile'])
					this.deleteFromServer(this.currentValue[0]['keyfile'])

				// просто чистим весь массив
				this.currentValue = []
			}

			// сообщим родителям что значение изменилось
			this.$emit('input', this.makeCurValue())
		},
		//---------------------------------------------------------------------
		// удаление файла с сервера по его ключу
		//---------------------------------------------------------------------
		deleteFromServer(keyfile) {
			// если нет ключа - ничего не делаем
			if (!keyfile) return
			// удаляем асинхронно, результат не интересен
			this.$store.commit('needShowLoader', false)
			this.$http.get(this.APIServerUrl + '/upload/delete/' + keyfile)
				.then(
					() => this.$store.commit('needShowLoader', true),
					() => this.$store.commit('needShowLoader', true)
				)
				.catch(() => {
					if (this.$store.state.isDebug) window.DEBUG.error('FILE (dfs01): файл не найден')
				})
		},
		//---------------------------------------------------------------------
		// отменяет загрузку файла на сервер
		//---------------------------------------------------------------------
		cancelUploading(item) {
			// проверка параметра
			if (!item) return

			// если есть объект xhr - значит идет загрузка
			if (item['xhr'])
			{
				// отменяем загрузку
				item['xhr'].abort()
				// сообщаем родителям что прервали загрузку
				this.$emit('abortUpload', true)
			}

			// удаляем из текущего массива
			if (item['id'])
			{
				// ищем по ID так как объект изменился
				for (let i = 0; i < this.currentValue.length; i++)
				{
					if (this.currentValue[i] && String(this.currentValue[i]['id']) === String(item['id']))
					{
						this.currentValue.splice(i, 1)
						break
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// просмотр картинки в диалоге
		//---------------------------------------------------------------------
		previewImage(item) {
			if (!item || !item['image'] || !item['image'].src) return

			this.modalItemID = item['id']
			this.modalText = item['title']

			let image = new Image()
			image.src = item['image'].src

			// конец загрузки картинки
			image.onload = () => {
				// просто поменяем источник - браузер сам возьмет картинку из кеша
				this.$refs['imageInDialog'].src = image.src

				// рассчитаем сразу размеры
				this.imageNaturalWidth = image.naturalWidth
				this.imageNaturalHeight = image.naturalHeight

				this.imageWidth = image.naturalWidth
				this.imageHeight = image.naturalHeight

				// текущая ширина окна
				let windowWidth = this.$store.state.windowWidth
				let windowHeight = this.$store.state.windowHeight

				// максимальные размеры
				let _delta = 40

				if (windowWidth <= 420)
				{
					_delta = 20
				}
				if (windowWidth > 420 && windowWidth <= 767)
				{
					_delta = 30
				}
				if (windowWidth > 767 && windowWidth <= 900)
				{
					_delta = 40
				}
				else _delta = 60

				let maxWidth = windowWidth - _delta
				let maxHeight = windowHeight - 190
				if (maxWidth < 100) maxWidth = 100
				if (maxHeight < 100) maxHeight = 100

				// пропорционально уменьшаем
				let _k = 1
				if (this.imageWidth > maxWidth || this.imageHeight > maxHeight)
				{
					if (this.imageWidth > this.imageHeight) _k = maxWidth / this.imageWidth
					else _k = maxHeight / this.imageHeight

					this.imageWidth = parseInt(this.imageWidth * _k)
					this.imageHeight = parseInt(this.imageHeight * _k)

					// дополнительная проверка на высоту
					if (this.imageHeight > maxHeight)
					{
						_k = maxHeight / this.imageHeight
						this.imageWidth = parseInt(this.imageWidth * _k)
						this.imageHeight = parseInt(this.imageHeight * _k)
					}
				}

				// запоминаем коэффициент сжатия
				this.scaleKoeff = _k

				this.modalWidth = this.imageWidth + 30
				if (this.modalWidth < 200) this.modalWidth = 200

				// если требуется Crop
				if (this.modalCrop)
				{
					// включаем превьюшки
					this.$refs['previewCropSquare'].src = image.src
					this.$refs['previewCropRound'].src = image.src

					// запоминаем ссылки
					this.$square = $(this.$refs['previewCropSquare'])
					this.$round = $(this.$refs['previewCropRound'])

					// проверка jcrop - если уже есть, уберем
					if (typeof window.jcrop_api !== 'undefined')
					{
						if (window.jcrop_api) window.jcrop_api.destroy()
						window.jcrop_api = null
					}

					// делаем выделение сразу на всю наименьшую сторону
					let _side = 100
					if (this.imageNaturalWidth > this.imageNaturalHeight) _side = this.imageNaturalHeight
					else _side = this.imageNaturalWidth

					// создаем по новой jcrop
					$(this.$refs['imageInDialog']).Jcrop(
						{
							aspectRatio: 1,
							setSelect: [0, 0, _side, _side],
							onChange: this.renderCropPreview,
							bgColor: '',
							bgOpacity: 0.3,
							boxWidth: this.imageWidth,
							boxHeight: this.imageHeight
						},
						function () {
							window.jcrop_api = this
						}
					)
				}

				EventBus.$emit('w5-body-scroll-disable')
				this.showModal = true
			}
		},
		//---------------------------------------------------------------------
		// рендер Crop превьюшки
		//---------------------------------------------------------------------
		renderCropPreview(coords) {
			// выделение должно быть всегда
			if (coords.w < 40 || coords.h < 40)
			{
				coords.w = 40
				coords.h = 40
				window.jcrop_api.setSelect([ coords.x, coords.y, coords.x + coords.w, coords.y + coords.h ])
			}

			// запоминаем координаты crop с реальными размерами картинки
			this.cropCoords = Object.assign({
				'naturalWidth': this.imageNaturalWidth,
				'naturalHeight': this.imageNaturalHeight,
				'imageWidth': this.imageWidth,
				'imageHeight': this.imageHeight
			}, coords)

			let rx = 40 / coords.w
			let ry = 40 / coords.h

			this.$square.css({
				width: Math.round(rx * this.imageNaturalWidth) + 'px',
				height: Math.round(ry * this.imageNaturalHeight) + 'px',
				marginLeft: '-' + Math.round(rx * coords.x) + 'px',
				marginTop: '-' + Math.round(ry * coords.y) + 'px'
			})

			this.$round.css({
				width: Math.round(rx * this.imageNaturalWidth) + 'px',
				height: Math.round(ry * this.imageNaturalHeight) + 'px',
				marginLeft: '-' + Math.round(rx * coords.x) + 'px',
				marginTop: '-' + Math.round(ry * coords.y) + 'px'
			})
		},
		//---------------------------------------------------------------------
		// добавляет итем
		//---------------------------------------------------------------------
		onSelect(e) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим выбранные файлы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.errors = ''
			let files = e.target.files
			let len = files['length']
			// если файлов нет - ничего не делаем
			if (len <= 0) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всему списку файлов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _id = ''
			let _type = ''
			let _isAcceptType = false
			let _ans = null

			for (let i = 0; i < len; i++)
			{
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// по умолчанию запрещенный тип
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				_isAcceptType = false

				// определим тип
				_ans = this.verifyFileType(files[i])
				_isAcceptType = _ans['isAccept']
				_type = _ans['type']

				// если тип запрещен (или не определился)
				if (!_isAcceptType)
				{
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
					else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
					continue
				}
				else
				{
					// запомним тип, если это массив
					if ($.isArray(_type) && _type.length) _type = _type[0]
				}

				// еще раз проверим итоговый тип
				if (_type === undefined || _type === null || $.trim(_type) === '')
				{
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
					else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/incorrect_filetype'
					continue
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// проверка на размер файла
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (files[i]['size'] > this.maxsize)
				{
					// формируем текст ошибки
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + Helper.FormatBytes(this.maxsize) + ')'
					else this.errors += '<br><b>' + files[i]['name'] + '</b> upload/too_big_file (max: ' + Helper.FormatBytes(this.maxsize) + ')'
					continue
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// проверка на количество файлов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (this.currentValue.length >= this.maxcount)
				{
					// формируем текст ошибки
					if (this.errors === '') this.errors = '<b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount)
					else this.errors += '<br><b>' + files[i]['name'] + '</b> ' + this.localeFtc('main/max_files_error').replace('{max}', this.maxcount)
					continue
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				//
				// запоминаем
				//
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// уникальный ключ
				_id = Helper.unixTime(true)

				this.currentValue.push({
					'id': _id,
					'url': files[i]['name'],
					'type': _type,
					'ext': Helper.getFileExt(files[i]['name']).toUpperCase().substr(0, 4),
					'title': files[i]['name'],
					'status': '',
					'size': 0,
					'local': files[i]
				})

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// грузим в компонент
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				this.loadFile(_id)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// загружаем на сервер только если не нужен crop или
				// это множественный лоадер (что то же самое)
				// при crop'e - файл будет загружен после crop'a
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (this.crud !== 'options' || this.multiple) this.uploadFile(_id)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			} // for

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// в любом случае - чистим input[type=file] для кнопки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$refs['fileUploaderInput'].value = ''
		},
		//---------------------------------------------------------------------
		// проверка типа файла
		//---------------------------------------------------------------------
		verifyFileType(File) {
			// готовим ответ
			let _ans = {
				'isAccept': false,
				'type': null
			}

			// 1. сначала пытаемся определить тип файла по расширению
			// получим все типы по расширению файла (массив)
			let _type = this.getTypeByName(File['name'], true)

			// бежим по полученному массиву типов
			for (let x = 0; x < _type.length; x++)
			{
				// текущий тип
				let _v = _type[x]

				// если допустимый тип это массив (список)
				if ($.isArray(this.accept))
				{
					// если есть в списке
					if ($.inArray(_v, this.accept) >= 0)
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _v
						return _ans
					}
				}
				// если допустимый тип это просто строка
				else if (typeof this.accept === 'string')
				{
					if (_v.match(this.accept))
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _v
						return _ans
					}
				}
			}

			// 2. если дошли до сюда, значит не удалось определить тип по расширению
			// будем пытаться определить тип если MIME тип определился браузером
			if (File['type'] !== '')
			{
				// запоминаем тип
				_type = File['type']
				// проверяем его
				if ($.isArray(this.accept))
				{
					if ($.inArray(_type, this.accept) >= 0)
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _type
						return _ans
					}
				}
				else if (typeof this.accept === 'string')
				{
					if (_type.match(this.accept))
					{
						// у нас есть ответ
						_ans['isAccept'] = true
						_ans['type'] = _type
						return _ans
					}
				}
			}

			// так и не удалось получить тип
			return _ans
		},
		//---------------------------------------------------------------------
		// получение типа файла по его названию
		//---------------------------------------------------------------------
		getTypeByName(value, all) {
			// получим расширение файла и будем смотреть на него
			let _ext = Helper.getFileExt(value).toLowerCase()
			// получим по расширению MIME тип
			let _arr = []
			_arr.push(_ext)

			let _type = this.getMimes(_arr)

			// если требуется только первый тип
			if (!all)
			{
				if (_type.length) _type = _type[0]
				else _type = 'unknown'
			}

			// вренем массив
			return _type
		},
		//---------------------------------------------------------------------
		// получение MIME по расширению файла
		//---------------------------------------------------------------------
		getMimes(extensions) {
			// MIME типы
			let _mimeTypes = {
				'csv': ['text/x-comma-separated-values', 'text/comma-separated-values', 'application/octet-stream', 'text/csv', 'application/csv'],
				'bin': 'application/octet-stream',
				'psd': 'application/x-photoshop',
				'oda': 'application/oda',
				'pdf': ['application/pdf', 'application/x-download'],
				'ai': 'application/postscript',
				'eps': 'application/postscript',
				'ps': 'application/postscript',
				'xls': ['application/excel', 'application/vnd.ms-excel', 'application/msexcel'],
				'ppt': ['application/powerpoint', 'application/vnd.ms-powerpoint'],
				'wbxml': 'application/wbxml',
				'wmlc': 'application/wmlc',
				'gtar': 'application/x-gtar',
				'gz': 'application/x-gzip',
				'swf': 'application/x-shockwave-flash',
				'tar': 'application/x-tar',
				'tgz': 'application/x-tar',
				'xhtml': 'application/xhtml+xml',
				'xht': 'application/xhtml+xml',
				'zip': ['application/x-zip', 'application/zip', 'application/x-zip-compressed'],
				'mid': 'audio/midi',
				'midi': 'audio/midi',
				'mpga': 'audio/mpeg',
				'mp2': 'audio/mpeg',
				'mp3': ['audio/mpeg', 'audio/mpg'],
				'aif': 'audio/x-aiff',
				'aiff': 'audio/x-aiff',
				'aifc': 'audio/x-aiff',
				'ram': 'audio/x-pn-realaudio',
				'rm': 'audio/x-pn-realaudio',
				'rpm': 'audio/x-pn-realaudio-plugin',
				'ra': 'audio/x-realaudio',
				'rv': 'video/vnd.rn-realvideo',
				'wav': 'audio/x-wav',
				'bmp': 'image/bmp',
				'gif': 'image/gif',
				'jpeg': ['image/jpeg', 'image/pjpeg'],
				'jpg': ['image/jpeg', 'image/pjpeg'],
				'jpe': ['image/jpeg', 'image/pjpeg'],
				'png': ['image/png', 'image/x-png'],
				'tiff': 'image/tiff',
				'tif': 'image/tiff',
				'css': 'text/css',
				'html': 'text/html',
				'htm': 'text/html',
				'shtml': 'text/html',
				'txt': 'text/plain',
				'text': 'text/plain',
				'log': ['text/plain', 'text/x-log'],
				'rtx': 'text/richtext',
				'rtf': 'text/rtf',
				'xml': 'text/xml',
				'xsl': 'text/xml',
				'mpeg': 'video/mpeg',
				'mpg': 'video/mpeg',
				'mpe': 'video/mpeg',
				'qt': 'video/quicktime',
				'mov': 'video/quicktime',
				'avi': 'video/x-msvideo',
				'movie': 'video/x-sgi-movie',
				'doc': 'application/msword',
				'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'word': ['application/msword', 'application/octet-stream'],
				'xl': 'application/excel',
				'eml': 'message/rfc822',
				'iso': ['application/x-iso9660-image', 'application/x-iso-image'],
				'sig': 'application/octet-stream'
			}

			let mimes = []
			for (let i in extensions)
			{
				let ext = extensions[i]

				if (ext in _mimeTypes)
				{
					let mime = _mimeTypes[ext]

					if ($.isArray(mime))
						$.merge(mimes, mime)
					else
						mimes.push(mime)
				}
			}

			return mimes
		},
		//---------------------------------------------------------------------
		// копирование из буфера картинки
		//---------------------------------------------------------------------
		pasteFromClipboard(e) {
			if (!e || !e.clipboardData || !e.clipboardData.items)
			{
				return
			}

			let items = e.clipboardData.items
			let files = []
			for (let i = 0; i < items.length; i++)
			{
				// если это не картинка - пропустим
				if (items[i].type.indexOf('image') !== 0) continue

				// получим картинку как blob
				let blob = items[i].getAsFile()

				// добавим в список
				files.push(blob)
			}

			// эмулируем выбор файла
			this.onSelect({
				target: {
					files
				}
			})
		},
		//---------------------------------------------------------------------
		// закрытие диалога по ESC
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			if (this.showModal && e.keyCode === 27)
			{
				this.closeDialog()
			}
		},
		//---------------------------------------------------------------------
		// закрытие диалога
		//---------------------------------------------------------------------
		closeDialog(event, endCrop, onMask) {
			// если у нас Crop
			if (this.modalCrop)
			{
				// если это клик по бэкграунду диалога - запрет закрытия
				if (onMask) return
				// и если это не конец Crop'a - нужно обнулить
				if (!endCrop)
				{
					// если есть значения
					for (let i in this.currentValue)
						this.deleteItem(this.currentValue[i])
				}
			}
			// нужно ли закрывать маску
			let canCloseMask = true
			if (this.crud === 'twofa' && this.name === 'image')
				canCloseMask = false
			// в любых других случаях - закроем
			if (canCloseMask) EventBus.$emit('w5-body-scroll-enable')
			this.showModal = false
			if (canCloseMask) this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// закончили Crop
		//---------------------------------------------------------------------
		finishCrop(e) {
			// разрешаем закрыть диалог
			this.modalCrop = false

			// проверка jcrop - если уже есть, уберем
			if (typeof window.jcrop_api !== 'undefined')
			{
				if (window.jcrop_api) window.jcrop_api.destroy()
				window.jcrop_api = null
			}

			// сообщаем родителям выбранные координаты
			this.$emit('cropCoords', this.cropCoords)

			// загружаем итем на сервер
			this.uploadFile(this.modalItemID)

			// закрываем диалог с признаком конца Crop'a
			this.closeDialog(e, true)
		},
		//---------------------------------------------------------------------
		// формируем текущее значение
		//---------------------------------------------------------------------
		makeCurValue() {
			if (this.multiple)
			{
				if (this.currentValue && this.currentValue.length)
				{
					let _value = []
					this.currentValue.forEach(item => {
						if (item['keyfile'] && item['keyfile'] !== '') _value.push(item['keyfile'])
						else _value.push(item['url'])
					})

					return _value.length > 0 ? _value : null
				}
			}
			else
			{
				if (this.currentValue && this.currentValue[0])
				{
					if (this.currentValue[0]['keyfile'] && this.currentValue[0]['keyfile'] !== '') return this.currentValue[0]['keyfile']
					else return this.currentValue[0]['url']
				}
			}

			// значение по умолчанию
			return null
		},
		//---------------------------------------------------------------------
		// обнуление ошибок
		//---------------------------------------------------------------------
		clearErrors() {
			this.errors = ''
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		//---------------------------------------------------------------------
		// родитель изменил значение
		//---------------------------------------------------------------------
		'value': function(value) {
			if (this.multiple)
			{
				// если пришло значение
				if (value)
				{}
				else
				{
					// пришло нулевое значение
					this.currentValue = []
				}
			}
			else
			{
				// если все же задано какое то значение
				if (value)
				{
					// частный случай
					if (this.crud === 'options' && value.indexOf('/uploads/avatars/default') === 0)
					{
						// все равно что пустое значение
						this.currentValue = []
						return
					}

					// если это просто пришел заданный ключ
					if (this.currentValue &&
						Array.isArray(this.currentValue) &&
						this.currentValue[0] &&
						this.currentValue[0]['keyfile'] === value)
					{
						// ничего не делаем
						return
					}

					// значит это установили новое значение - обнулим текущее
					this.currentValue = []

					// уникальный ключ
					let _id = Helper.unixTime(true)

					this.currentValue.push({
						'id': _id,
						'url': value,
						'ext': Helper.getFileExt(value).toUpperCase().substr(0, 4),
						'type': this.getTypeByName(value),
						'title': 'main/loaded_image',
						'status': '',
						'size': 0,
						'local': false,
						'keyfile': null
					})

					// загружаем файл
					this.loadFile(_id)
				}
				else
				{
					// пришло нулевое значение
					this.currentValue = []
				}
			}
		},
		//---------------------------------------------------------------------
		// изменился URL
		//---------------------------------------------------------------------
		'$route': function(to, from) {
			// нужно прервать все загрузки
			this.currentValue.forEach(item => {
				this.cancelUploading(item)
			})
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-file-component {
	min-height: 45px;	
}

.w5-file-add-button {
	display: inline-block;
	position: relative;
	float: left;    
	text-align: center;
	padding: 6px;    
	margin-top: 6px;
	color: white;
	background: #2c8ad8;
	transition: background-color 0.3s;
	border: none;    
	border-radius: 4px;
	overflow: hidden;
	cursor: pointer;
}
.w5-application.mc .w5-file-add-button {
	background: #01196f;
}

.w5-file-add-button:hover {
	background-color: #3ba3ff;
}
.w5-application.mc .w5-file-add-button:hover {
	background-color: #1b379c;
}


.w5-file-add-button > svg {
	position: relative;
	top: 1px;
	margin-left: 5px;
}

.w5-file-add-button > .w5-file-add-button-caption {
	cursor: pointer;
}

.w5-file-add-button > input[type='file'] {
	width: 200px !important;
	height: 34px !important;
	padding: 0  !important;
	margin: 0  !important;
	opacity: 0;
	position: absolute  !important;
	top: 0;
	right: 0;
	cursor: pointer;
}

.w5-file-add-button-caption {
	display: inline;
	margin: 0 10px;
	position: relative;
	top: 0;
	font-size: 13px;
	font-weight: 400;    
}

.w5-file-uploader-item {
	display: flex;
	justify-content: space-between;
	border: 1px solid #ddd;
	padding: 4px;
	border-radius: 4px;
}

.w5-file-uploader-item.multiple-item {
	margin: 2px 0;
}

.w5-file-uploader-item-image-wrapper {
	display: flex;
	height: 35px;
	width: 35px;
	text-align: center;
	align-items: center;
	-webkit-align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4);
}

.w5-file-uploader-item-image-wrapper > img {
	width: 35px;
	height: 35px;
	cursor: pointer;
}

.w5-file-uploader-item-image-wrapper > svg {
	font-size: 27px;
	color: #aaa;	
}

.w5-file-uploader-item-title {
	padding-left: 10px;
	display: flex;
	align-items: center;
	-webkit-align-items: center;
	height: 35px;    
	font-weight: 400;
	font-size: 13px;
	width: calc(100% - 160px);
	overflow: hidden;
}

.w5-file-uploader-item-size {
	padding-left: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-align-items: center;
	height: 35px;    
	font-weight: 400;
	font-size: 13px;
	width: 80px;
	overflow: hidden;
}

.w5-file-uploader-item-buttons {
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-align-items: center;
	height: 35px;    
	font-size: 100%;
	width: 40px;        
}

.w5-file-uploader-item-buttons > svg {
	color: #999;
	cursor: pointer;
	transition: color 0.3s;
}
.w5-file-uploader-item-buttons > svg:hover {
	color: red;
}

.attach-no-image-preview-file-uploader {
	height: 20px;
	width: 33px;
	background-image: url(../../assets/img/file.svg);
	background-repeat: no-repeat;
	background-size: contain;
	background-position-x: 2px;
	text-align: center;
	color: white;
	font-size: 9px;
	font-weight: 400;
	line-height: 23px;
}

/* ножницы для обрезки */
@-webkit-keyframes miganie-animation {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
@keyframes miganie-animation {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.miganie-animation {
  -webkit-animation: miganie-animation 1s linear infinite;
  animation: miganie-animation 1s linear infinite;
}

@media (max-width: 767px) {
	.w5-file-uploader-item {
		/* flex-direction: column; */
	}

	.w5-file-uploader-item-image-wrapper {
		/* margin-bottom: 5px; */
	}

	.w5-file-uploader-item-title {
		width: 100%;
		line-height: 1;
		overflow: hidden;
		font-size: 11px;
		/* margin-bottom: 5px; */
	}

	.w5-file-uploader-item-size {
		width: 80%;
		line-height: 1;
		overflow: hidden;
		font-size: 11px;
	}

	.w5-file-uploader-item-buttons {
		position: absolute;
		top: 14px;
		right: 0;
		display: block;
		padding-top: 10px;
		padding-left: 15px;
	}
	.w5-file-uploader-item-buttons > svg {
		color: red;
	}
}

.w5-image-preview-crop-wrapper {
	position: relative;
	margin: 5px;
	padding: 0;
	width: 40px;
	height: 40px;
	display: inline-block;
	overflow: hidden;
}

.w5-image-preview-crop-wrapper.round {
	border-radius: 20px;
}

.w5-image-preview-crop {	
	position: absolute;	
	margin: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

/* jquery.Jcrop.min.css v0.9.12 (build:20130126) */
.jcrop-holder{direction:ltr;text-align:left;}
.jcrop-vline,.jcrop-hline{background:#FFF url(../../assets/img/Jcrop.gif);font-size:0;position:absolute;}
.jcrop-vline{height:100%;width:1px!important;}
.jcrop-vline.right{right:0;}
.jcrop-hline{height:1px!important;width:100%;}
.jcrop-hline.bottom{bottom:0;}
.jcrop-tracker{-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;height:100%;width:100%;}
.jcrop-handle{background-color:#333;border:1px #EEE solid;font-size:1px;height:7px;width:7px;}
.jcrop-handle.ord-n{left:50%;margin-left:-4px;margin-top:-4px;top:0;}
.jcrop-handle.ord-s{bottom:0;left:50%;margin-bottom:-4px;margin-left:-4px;}
.jcrop-handle.ord-e{margin-right:-4px;margin-top:-4px;right:0;top:50%;}
.jcrop-handle.ord-w{left:0;margin-left:-4px;margin-top:-4px;top:50%;}
.jcrop-handle.ord-nw{left:0;margin-left:-4px;margin-top:-4px;top:0;}
.jcrop-handle.ord-ne{margin-right:-4px;margin-top:-4px;right:0;top:0;}
.jcrop-handle.ord-se{bottom:0;margin-bottom:-4px;margin-right:-4px;right:0;}
.jcrop-handle.ord-sw{bottom:0;left:0;margin-bottom:-4px;margin-left:-4px;}
.jcrop-dragbar.ord-n,.jcrop-dragbar.ord-s{height:7px;width:100%;}
.jcrop-dragbar.ord-e,.jcrop-dragbar.ord-w{height:100%;width:7px;}
.jcrop-dragbar.ord-n{margin-top:-4px;}
.jcrop-dragbar.ord-s{bottom:0;margin-bottom:-4px;}
.jcrop-dragbar.ord-e{margin-right:-4px;right:0;}
.jcrop-dragbar.ord-w{margin-left:-4px;}
.jcrop-light .jcrop-vline,.jcrop-light .jcrop-hline{background:#FFF;filter:alpha(opacity=70)!important;opacity:.70!important;}
.jcrop-light .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#000;border-color:#FFF;border-radius:3px;}
.jcrop-dark .jcrop-vline,.jcrop-dark .jcrop-hline{background:#000;filter:alpha(opacity=70)!important;opacity:.7!important;}
.jcrop-dark .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#FFF;border-color:#000;border-radius:3px;}
.solid-line .jcrop-vline,.solid-line .jcrop-hline{background:#FFF;}
.jcrop-holder img,img.jcrop-preview{max-width:none;}

</style>



// WEBPACK FOOTER //
// file.vue?988cca66